
import axios from 'axios';
import { BASE_API_URL } from './baseServices';

export const fetchSections = async (deptId) => {
    try {
        const response = await axios.get(`${BASE_API_URL}ADMINRoutes/GetSections?DeptId=${deptId}`);
        return response.data.ResultData;
    } catch (error) {
        console.error('Error fetching departments:', error);
        throw error;
    }
};

export const addSection = async (data) => {
    const payload = {
      ...data
    };
  
    return axios.post(`${BASE_API_URL}ADMINRoutes/CreateSections`, payload);
  };
  
export const updateSection = async (data) => {
    const payload = {
        ...data,
        IsActive: 1
    };

    return axios.post(`${BASE_API_URL}ADMINRoutes/EditSections`, payload);
};

export const inActiveSection = async (data) => {
    const payload = {
        ...data,
    };

    return axios.post(`${BASE_API_URL}ADMINRoutes/INACTIVESections`, payload);
};
